angular.module('bmsApp.settings')
	.service('TextInsert', function () {
		return {
			insert: function (input, text) {
				var back, browser, front, pos, range, scrollPos;
				if (!input) {
					return;
				}
				scrollPos = input.scrollTop;
				pos = 0;
				browser = input.selectionStart || input.selectionStart === '0' ? 'ff' : document.selection ? 'ie' : false;
				if (browser === 'ie') {
					input.focus();
					range = document.selection.createRange();
					range.moveStart('character', -input.value.length);
					pos = range.text.length;
				}
				else if (browser === 'ff') {
					pos = input.selectionStart;
				}
				front = input.value.substring(0, pos);
				back = input.value.substring(pos, input.value.length);
				input.value = front + text + back;
				pos = pos + text.length;
				if (browser === 'ie') {
					input.focus();
					range = document.selection.createRange();
					range.moveStart('character', -input.value.length);
					range.moveStart('character', pos);
					range.moveEnd('character', 0);
					range.select();
				}
				else if (browser === 'ff') {
					input.selectionStart = pos;
					input.selectionEnd = pos;
					input.focus();
				}
				input.scrollTop = scrollPos;
				angular.element(input)
					.trigger('input');
				return '';
			}
		};

	});
